import React from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Modal,
  Button,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';

import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';

export function DynamicModal(props: any) {
  const {
    open,
    heading,
    cancelBtn,
    saveBtn,
    onClose,
    saveBtnHandler,
    type,
    description,
    emailBtnText,
    phoneBtnText,
    description2,
    handlePhone,
    handleEmail,
    apiLoading,
    contactDataLoading,
    showDiffEmailBtn,
  } = props;

  return (
    <Box>
      <Modal.Root open={open}>
        <Modal.Content
          showCloseButton={false}
          data-testid="mainModal"
          css={
            {
              borderRadius: 'initial',
              background: '#fff',
              padding: '20px 30px',

              '.GDS-modal': {
                borderRadius: '$none',
                // '.GDS-c-bVpebC-igUcHly-css': {
                margin: '0px',
                // height: '100vh'
                // height: ['Firefox'].includes(browser) ? '100vh' : '',
                // maxHeight: ['Firefox'].includes(browser) ? '720px' : 'initial',
              },
            } as GDSStyleObject
          }
          width={{
            '@initial': 'standard',
            '@laptop': '38%',
            '@mobileLandscape': '50%',
            '@tablet': '50%',
          }}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <StackLayout
            css={{
              textAlign: 'center',
              alignItems: 'center',
              opacity: apiLoading || contactDataLoading ? 0.1 : 'initial',
            }}
          >
            <Box
              css={
                {
                  margin: '$one',
                  backgroundColor: 'White',
                } as GDSStyleObject
              }
            >
              <img
                style={{ cursor: 'pointer' }}
                src={
                  useStaticAsset(
                    SHARED_LIBRARY_ASSET_KEYS.FAILURE_ICON,
                  ) as string
                }
                alt="right arrow icon"
                width="45px"
              />
              <HeadingText
                data-testid="title"
                level="3"
                size="sm"
                css={
                  {
                    paddingTop: '$one',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '32px',
                    fontSize: 24,
                    color: '#2C3135',
                  } as GDSStyleObject
                }
              >
                {heading}
              </HeadingText>
              <ParagraphText
                data-testid="description"
                css={
                  {
                    margin: '$two $none $one $none',
                    padding: '$none $oneAndHalf',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '24px',
                    fontSize: 16,
                    color: '#2C3135',
                  } as GDSStyleObject
                }
              >
                {description}
              </ParagraphText>
              {type === 'NEW_EMAIL_CONFIRM' && (
                <ParagraphText
                  data-testid="description2"
                  css={
                    {
                      margin: '$one',
                      padding: '$none $oneAndHalf',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                      fontSize: 16,
                      color: '#2C3135',
                    } as GDSStyleObject
                  }
                >
                  {description2}
                </ParagraphText>
              )}
              <StackLayout
                horizontalAlignment="start"
                data-testid="button-section"
                css={{
                  flexDirection: [
                    'EMAIL_VERIFY',
                    'PREFERENCE_SELECT',
                    'VERIFY_ERROR',
                  ].includes(type)
                    ? 'collumn'
                    : 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {type !== 'API_FAILED' &&
                  type !== 'RESEND_ERROR' &&
                  type !== 'CUSTOMER_SUPPORT' &&
                  type !== 'NEW_EMAIL_CONFIRM' && (
                    <Button
                      size="small"
                      data-testid="send-email"
                      css={
                        {
                          color: '#0074C9',
                          cursor: 'pointer',
                          fontWeight: '700',
                          fontSize: 16,
                          // outline: 'none !important',
                          padding: [
                            'EMAIL_VERIFY',
                            'PREFERENCE_SELECT',
                            'VERIFY_ERROR',
                          ].includes(type)
                            ? '$one'
                            : '$two',
                          background: 'none',
                          '&:hover,&:active,&:focus': {
                            background: 'none',
                          },
                        } as GDSStyleObject
                      }
                      onClick={
                        [
                          'EMAIL_VERIFY',
                          'PREFERENCE_SELECT',
                          'VERIFY_ERROR',
                        ].includes(type)
                          ? handleEmail
                          : onClose
                      }
                    >
                      {[
                        'EMAIL_VERIFY',
                        'PREFERENCE_SELECT',
                        'VERIFY_ERROR',
                      ].includes(type)
                        ? emailBtnText
                        : cancelBtn}
                    </Button>
                  )}

                {showDiffEmailBtn ||
                type === 'API_FAILED' ||
                type === 'GENERAL' ||
                type === 'PREFERENCE_SELECT' ||
                type === 'VERIFY_ERROR' ||
                type === 'NEW_EMAIL_CONFIRM' ||
                type === 'RESEND_ERROR' ? (
                  <Button
                    size="small"
                    data-testid="save-btn"
                    css={
                      {
                        color: '#0074C9',
                        cursor: 'pointer',
                        fontWeight: '700',
                        fontSize: 16,
                        // outline: 'none !important',
                        padding: [
                          'EMAIL_VERIFY',
                          'PREFERENCE_SELECT',
                          'VERIFY_ERROR',
                        ].includes(type)
                          ? '$one'
                          : '$one',
                        background: 'none',
                        '&:hover,&:active,&:focus': {
                          background: 'none',
                        },
                      } as GDSStyleObject
                    }
                    onClick={
                      // eslint-disable-next-line no-nested-ternary
                      [
                        'EMAIL_VERIFY',
                        'PREFERENCE_SELECT',
                        'VERIFY_ERROR',
                      ].includes(type)
                        ? handlePhone
                        : // eslint-disable-next-line no-nested-ternary
                        type === 'GENERAL'
                        ? saveBtnHandler
                        : type === 'NEW_EMAIL_CONFIRM'
                        ? handleEmail
                        : onClose
                    }
                  >
                    {[
                      'EMAIL_VERIFY',
                      'PREFERENCE_SELECT',
                      'VERIFY_ERROR',
                    ].includes(type)
                      ? phoneBtnText
                      : saveBtn}
                  </Button>
                ) : null}
                {[
                  'EMAIL_VERIFY',
                  'PREFERENCE_SELECT',
                  'NEW_EMAIL_CONFIRM',
                  'VERIFY_ERROR',
                ].includes(type) && (
                  <Button
                    size="small"
                    data-testid="cancel-btn"
                    css={
                      {
                        color: '#0074C9',
                        cursor: 'pointer',
                        fontWeight: '700',
                        fontSize: 16,
                        padding: '$one',
                        background: 'none',
                        // outline: 'none !important',
                        '&:hover,&:active,&:focus': {
                          background: 'none',
                        },
                      } as GDSStyleObject
                    }
                    onClick={onClose}
                  >
                    {cancelBtn}
                  </Button>
                )}
              </StackLayout>
            </Box>
          </StackLayout>
          {(apiLoading || contactDataLoading) && <LoadingIndicator />}
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
